import colors from 'styles/colors';

const IconPriceCel = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
		<path
			fill={colors.celebrity.promoCardBlue}
			fillRule="evenodd"
			d="M2.446 2.448h10.06l8.306 8.306a2.55 2.55 0 0 1 0 3.596l-.001.001-6.453 6.453a2.55 2.55 0 0 1-3.608 0L2.446 12.51V2.45Zm1.5 1.5v7.94l7.865 7.855a1.052 1.052 0 0 0 1.486 0l6.452-6.45a1.05 1.05 0 0 0 0-1.48l-7.864-7.865H3.946Z"
			clipRule="evenodd"
		/>
		<path fill={colors.celebrity.promoCardBlue} fillRule="evenodd" d="M8.446 9.698a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" clipRule="evenodd" />
	</svg>
);
export default IconPriceCel;
